function helperNewDate () {
  return new Date()
}

module.exports = helperNewDate



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperNewDate.js
// module id = 78
// module chunks = 98